import { BenefitDTOBenefitEnum, DocumentsDTO } from 'probonio-shared-ui/api';
import { BenefitNavigationExtensionInterface } from '../../../../extension/interface/benefit-navigation.extension.interface';
import { BenefitMenuItemInterface } from '../../nav/BenefitMenuItem';

export class CouponsV2BenefitNavigationExtension extends BenefitNavigationExtensionInterface {
  getMenuItems({ documents }: { documents?: DocumentsDTO }): BenefitMenuItemInterface[] {
    const benefit = BenefitDTOBenefitEnum.CouponsV2.toLowerCase();
    return [
      { title: 'subPage.employees', to: `/benefits/${benefit}` },
      { title: 'couponsV2Module:budgetPage.subTitle', to: `/benefits/${benefit}/transactions` },
      { title: 'couponsV2Module:giftsPage.subTitle', to: `/benefits/${benefit}/gifts` },
      { title: 'subPage.payrollReport', to: `/benefits/${benefit}/payrollReport` },
      ...(documents?.totalCount ? [{ title: 'subPage.documents', to: `/benefits/${benefit}/documents` }] : []),
    ];
  }
}
